import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const PrivacyPolicy = () => {
  const { language } = useLanguage();
  const isEnglish = language === 'en';

  const content = {
    en: {
      title: 'Privacy Policy',
      points: [
        'Shivpratap Multistate Nagari Co-op. Credit Society respects the privacy of all its members.',
        'We collect basic personal details like name, address, and contact number.',
        'We may also collect ID proof and financial information when required.',
        'The information is collected only for providing our services.',
        'We use the data for account opening and loan processing.',
        'Your information is stored safely in secure systems.',
        'Only authorized staff can access your information.',
        'We do not sell or share your personal data.',
        'Information may be shared only if required by law.',
        'Members can contact us for any privacy-related questions.'
      ]
    },
    mr: {
      title: 'गोपनीयता धोरण',
      points: [
        'Shivpratap Multistate Nagari Co-op. Credit Society respects the privacy of all its members.',
        'We collect basic personal details like name, address, and contact number.',
        'We may also collect ID proof and financial information when required.',
        'The information is collected only for providing our services.',
        'We use the data for account opening and loan processing.',
        'Your information is stored safely in secure systems.',
        'Only authorized staff can access your information.',
        'We do not sell or share your personal data.',
        'Information may be shared only if required by law.',
        'Members can contact us for any privacy-related questions.'
      ]
    }
  };

  const currentContent = isEnglish ? content.en : content.mr;

  return (
    <div className="bg-gray-50 min-h-screen py-16 mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-6 sm:p-10">
            <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
              {currentContent.title}
            </h1>
          </div>
          <div className="p-6 sm:p-10">
            <ul className="space-y-6">
              {currentContent.points.map((point, index) => (
                <li key={index} className="flex gap-4">
                  <div className="mt-2 w-2 h-2 rounded-full bg-purple-500 flex-shrink-0"></div>
                  <p className="text-gray-700 leading-relaxed text-lg">{point}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
